(function(angular){
	'use strict';
	
	angular
		.module('investorUpdatesModule')
		.controller('OpinionPollModal', [
			'close',
			'ignoreClose',
			'opinionPoll',
			OpinionPollModalFunction
		]);
	
	function OpinionPollModalFunction(
		close,
		ignoreClose,
		opinionPoll
	){
		var opinionPollModal = this;
		opinionPollModal.opinionPoll = opinionPoll;
		opinionPollModal.close = close;
		opinionPollModal.ignoreClose = ignoreClose;
	}
})(window.angular);